import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { faStickyNote } from '@fortawesome/free-solid-svg-icons';

const MethodologyLink = (props) => {
  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext);
  // temp fix for broken root page
  return locale === 'zz' ? (
    <>
      <FontAwesomeIcon className='icon' icon={faStickyNote} />
      <Link href='/methodology'>
        <a>{props.children ? props.children : content.common.nav.methodology}</a>
      </Link>
    </>
  ) : (
    <>
      <FontAwesomeIcon className='icon' icon={faStickyNote} />
      <Link href='/[locale]/methodology' as={`/${locale}/methodology`}>
        <a>{props.children ? props.children : content.common.nav.methodology}</a>
      </Link>
    </>
  );
};

export default MethodologyLink;
